import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function ArticlesSection() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold uppercase tracking-wider mb-4">
            SEO Guides &amp; Tips
          </span>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
            AllChinaBuy Spreadsheet Resources
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            In-depth guides to help you get the most out of your spreadsheet — from product picks to safety tips
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={article.slug}
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-300 transition-all duration-200 overflow-hidden cursor-pointer"
            >
              <div className="w-full h-44 md:h-48 relative overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-white/85 backdrop-blur-sm text-foreground-800 text-[10px] font-semibold uppercase tracking-wider">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="flex flex-col flex-1 p-5">
                <h3 className="font-display text-base md:text-lg font-bold text-foreground-900 mb-2 leading-snug group-hover:text-accent-600 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-xs md:text-sm leading-relaxed mb-4 flex-1 line-clamp-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between pt-3 border-t border-background-200/60">
                  <span className="text-[11px] text-foreground-400">{article.readTime}</span>
                  <span className="inline-flex items-center gap-1 text-xs font-semibold text-accent-600 group-hover:translate-x-1 transition-transform duration-200">
                    Read Article <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}